import { ApiUtility } from "./ApiUtility";

class QuoteService {
  
  route = "/posts";
  divinequotesRoute = "/api/Quotes";
  categoryRoute = "/api/settings/filters?lang=";


  getFilters = (lang: string, productFor: string) => {
    return ApiUtility.get(
      this.categoryRoute + lang + "&productFor=" + productFor
    );
  };

  // getDivineQuotesId(id: string) {
  //   return ApiUtility.get(
  //     this.divinequotesRoute + id + "?lang=" + localStorage.getItem("lan")
  //   );
  // }

   getDivineQuotesId(id: string) {
    // ensure there's a slash before the id
    const separator = this.divinequotesRoute.endsWith("/") ? "" : "/";
    return ApiUtility.get(
      this.divinequotesRoute + separator + id + "?lang=" + localStorage.getItem("lan")
    );
  }

  getDivineQuotes = (start: number, length: number ,sortValue :string = "" ) => {
    return ApiUtility.get(
      this.divinequotesRoute +
      "?start=" +
      start +
      "&length=" +
      length +
      (sortValue ? "&sort=" + sortValue : "")
    );
  };
}
export default new QuoteService();